/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Not_FoundInputs */

const cs_api_error_not_found = /** @type {(inputs: Api_Error_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka nebyla nalezena. Možná byla smazána.`)
};

const en_api_error_not_found = /** @type {(inputs: Api_Error_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item was not found. It may have been deleted.`)
};

/**
* | output |
* | --- |
* | "This item was not found. It may have been deleted." |
*
* @param {Api_Error_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_not_found = /** @type {((inputs?: Api_Error_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_not_found(inputs)
	return cs_api_error_not_found(inputs)
});